import Api from './Api'

export default {
    login(credentials) {
        return Api().post('auth/login', credentials);
    },
    associarUser(credentials) {
        return Api().post('users/associarAPI', credentials);
    },
    
    getUser(){
        return Api().get('users/profile');
    },
    getDataUser(){
        return Api().get('users/all_data');
    },
    create(formData){
        return Api().post('users/register', formData);
    },
    newPassVerifyEmail(userInput){
        return Api().post(`auth/newPassword/verify-user`, userInput );
    },
    newPassVerifyToken(token){
        return Api().post(`auth/newPassword/verify-token`, token);
    },
    newPass(credentials){
        return Api().post(`auth/newPassword`, credentials );
    },
    updateAddress(credentials){
        return Api().put('users/update_address', credentials);
    },
    updatePhones(phones){
        return Api().put('users/update_phones', phones);
    },
    updateProfileImage(image){
        const headers = {
            'Content-Type': 'multipart/form-data'
        };
        return Api().post(`users/upload-image`, { image }, { headers });
    }
}